/* eslint-disable no-param-reassign */

export default {
    namespaced: true,

    state: {
        showMobile: false,
        groups: {
            solutions: false,
        },
    },

    getters: {
        showGroup: state => group => !!state.groups[group],
    },

    mutations: {
        toggleMobile(state) {
            state.showMobile = !state.showMobile;
        },

        closeMobile(state) {
            state.showMobile = false;
        },

        toggleGroup(state, group) {
            state.groups[group] = !state.groups[group];
        },
    },
};
